const isLandscape = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  return window.matchMedia('(orientation: landscape)').matches && window.innerHeight < 425;
};

export default isLandscape;
